import { Component } from '@angular/core';

@Component({
  selector: 'app-no-permission',
  imports: [],
  templateUrl: './no-permission.html',
  styleUrl: './no-permission.css',
})
export class NoPermissionComponent {

}
